import { Route, Routes, Navigate, BrowserRouter } from "react-router-dom";
import "./App.scss";

// Shared Components
import ScrollToTop from "./components/scrolltotop/ScrollToTop";
import ContextApi from "./hooks/useContextApi.js";

// Public Pages
import AboutUs from "./pages/Aboutus/Aboutus.js";
import AllGalary from "./pages/allgalary/AllGalary";
import ContactUs from "./pages/contactus/ContactUs";
import EfgAqua from "./pages/efgaqua/EfgAqua";
import Efgf from "./pages/efgf/Efgf";
import Efgt from "./pages/efgt/Efgt";
import Eurasia from "./pages/eurasia/Eurasia";
import Galary from "./pages/galary/Galary";
import Home from "./pages/home/Home";
import HorizonSeaFood from "./pages/horizonseafood/HorizonSeaFood";
import MasalaBazaar from "./pages/masalabazaar/MasalaBazaar";
import Message from "./pages/message/Message";
import NotFound from "./pages/notfound/NotFound";
import Project from "./pages/projects/Project";
import Rosemco from "./pages/rosemco/Rosemco";
import Saidowla from "./pages/saidowla/Saidowla";
import ProductNewDesign from "./pages/product/ProductNewDesign.js";
import Product from "./pages/product/Product.js";
import Career from "./pages/Career/Career";

// Admin Pages
import Main from "./AdminSite/Main/Main.jsx";

import Dashboard from "./AdminSite/pages/Dashboard/Dashboard.jsx";
import Login from "./AdminSite/pages/Login/Login.jsx";
import PrivateRoute from "./PrivateRoute.jsx";
import AddNewProducts from "./AdminSite/pages/AddNewProducts/AddNewProducts.jsx";
import EditProductInfo from "./AdminSite/pages/EditProductInfo/EditProductInfo.jsx";
import ViewProductInfo from "./AdminSite/pages/ViewProductInfo/ViewProductInfo";
import ProductListView from "./pages/ProductListView/ProductListView";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import CatalogueUpload from "./AdminSite/pages/CatalogueUpload/CatalogueUpload.jsx";
import AddNewUser from "./AdminSite/pages/AddNewUser/AddNewUser.jsx";
import ResetPassword from "./AdminSite/pages/ResetPassword/ResetPassword.jsx";
import TestHome from "./pages/home/TestHome.jsx";

function App() {
  return (
    <ContextApi>
      <div className="bg"></div>
      <div className="App content">
        <BrowserRouter>
          <ScrollToTop>
            <Routes>
              {/* Public Site Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/products" element={<ProductNewDesign />} />
              <Route path="/productListView" element={<ProductListView />} />

              <Route
                path="/productDetails/:id"
                element={<ProductDetails />}
                loader={({ params }) =>
                  fetch(
                    `https://backend-server-nine-opal.vercel.app/contents/${params.id}`
                  )
                }
              />
              <Route path="/productsmain" element={<Product />} />
              <Route path="/aboutus" element={<AboutUs />} />
              {/* <Route path="/gallery" element={<Galary />}>
                <Route path="allprojects" element={<AllGalary />} />
                <Route path="eurasia" element={<Eurasia galary={false} />} />
                <Route path="rosemco" element={<Rosemco galary={false} />} />
                <Route path="efgf" element={<Efgf galary={false} />} />
                <Route path="saidowla" element={<Saidowla galary={false} />} />
                <Route
                  path="masalabazaar"
                  element={<MasalaBazaar galary={false} />}
                />
                <Route path="efgt" element={<Efgt galary={false} />} />
                <Route path="efgaqua" element={<EfgAqua galary={false} />} />
              </Route> */}

              {/* Shortcut Routes for Galary Items */}
              <Route path="/eurasia" element={<Eurasia galary={true} />} />
              <Route path="/efgf" element={<Efgf galary={true} />} />
              <Route path="/rosemco" element={<Rosemco galary={true} />} />
              <Route path="/efgt" element={<Efgt galary={true} />} />
              <Route path="/saidowla" element={<Saidowla galary={true} />} />
              <Route
                path="/masalabazaar"
                element={<MasalaBazaar galary={true} />}
              />
              <Route path="/efgaqua" element={<EfgAqua galary={true} />} />

              <Route path="/horizonseafood" element={<HorizonSeaFood />} />
              <Route path="/projects" element={<Project />} />
              <Route path="/contactus" element={<ContactUs />} />
              <Route path="/career" element={<Career />} />
              <Route path="/message" element={<Message />} />
              <Route path="/testHome" element={<TestHome />} />

              {/* Admin Panel Main Layout for login/register */}
              <Route path="/admin" element={<Main />}>
                <Route index element={<Navigate to="/admin/login" replace />} />
                <Route path="login" element={<Login />} />
                <Route path="resetPassword" element={<ResetPassword />} />
                {/* <Route path="register" element={<Register />} /> */}
              </Route>

              {/* Actual Dashboard Routes (not nested under /admin anymore) */}
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />

              <Route
                path="/dashboard/addNewUser"
                element={
                  <PrivateRoute>
                    <AddNewUser />
                  </PrivateRoute>
                }
              />

              <Route
                path="/dashboard/editProduct/:id"
                element={
                  <PrivateRoute>
                    <EditProductInfo />
                  </PrivateRoute>
                }
                loader={({ params }) =>
                  fetch(
                    `https://backend-server-nine-opal.vercel.app/contents/${params.id}`
                  )
                }
              />

              <Route
                path="/dashboard/viewProduct/:id"
                element={
                  <PrivateRoute>
                    <ViewProductInfo />
                  </PrivateRoute>
                }
                loader={({ params }) =>
                  fetch(
                    `https://backend-server-nine-opal.vercel.app/contents/${params.id}`
                  )
                }
              />

              <Route
                path="/dashboard/addNewProduct"
                element={
                  <PrivateRoute>
                    <AddNewProducts />
                  </PrivateRoute>
                }
              />
              <Route
                path="/dashboard/catalogueUpload"
                element={
                  <PrivateRoute>
                    <CatalogueUpload />
                  </PrivateRoute>
                }
              />

              {/* Not Found */}
              <Route path="/*" element={<NotFound />} />
            </Routes>
          </ScrollToTop>
        </BrowserRouter>
      </div>
    </ContextApi>
  );
}

export default App;
